import * as React from 'react';

export const header = {
  heading: 'What Do We Collect?'
};
export const richText = {
  id: 'WhatWeCollect',
  html:
    '                <p>As noted above, we collect personal information when you visit our stores,\n'
    + '                 when you contact us, when you interact with or use our digital offerings,\n'
    + '                 and from business partners and other third parties. \n'
    + '                <p><br/></p>\n'
    + '                <p>The table below describes the categories of personal information we collect, \n'
    + '                 the sources we collect the information from, our purposes for collecting the \n'
    + '                 information, and the types of recipients that may receive the information from us.\n'
    + '                 And you can find more details in the <a href="#WhatWeCollect">“What Do We Collect?”, \n'
    + '                 </a> <a href="#CollectInformation">“How Do We Collect Information?,”</a> \n'
    + '                 and <a href ="#InformationSharing"> “Information Sharing” </a>sections that follow </p> \n'
    + '                <p><br/></p>\n'
};
export const etchStories = [
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION'
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> IDENTIFIERS,</p>\n'
      + '     such as name, email address, phone number, username, physical address, device identifier, IP address,\n'
      + '     government-issued identification number, date of birth/age, license plate number, and social media handle. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Directly from you or the devices you use to access digital services, such as websites,\n'
        + '    mobile applications, and applications for connected devices </p> \n'
        + '    <p><br/></p> <p> Other customers that may provide us with your information to recommend a product or service,\n'
        + '    ship products to you, or list you as a recipient of products or services </p> \n'
        + '    <p><br/></p> <p> Companies that provide services on our behalf (e.g., installers). </p> \n'
        + '    <p><br/></p> <p> Security and fraud prevention services that help us confirm that transactions are valid and otherwise help us protect our assets and you.</p>\n'
        + '    <p><br/></p> <p> Marketing companies that help us learn about our customers and the devices they use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Companies that supplement our customer records with additional information.</p>\n'
        + '    <p><br/></p> <p> Shipping providers that update address information. </p>\n'
        + '    <p><br/></p> <p> Social media platforms.</p>\n'
        + '    <p><br/></p> <p> Advertising companies and content publishers that present you with our ads.</p> \n'
        + '    <p><br/></p> <p> Payment and transaction processors.</p>\n'
        + '    <p><br/></p> <p> Communications and mailing vendors.</p>\n'
        + '    <p><br/></p> <p> The signals emitted by your mobile devices when you travel through our stores.</p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Fulfilling orders and processing returns. </p> \n'
        + '    <p><br/></p> <p> Customer care.</p>\n'
        + '    <p><br/></p> <p> Administering contests and promotions. </p> \n'
        + '    <p><br/></p> <p> Registering you for a website or program.</p>\n'
        + '    <p><br/></p> <p> Marketing companies that help us learn about our customers and the devices they use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Communicating with you. </p> \n'
        + '    <p><br/></p> <p> Improving our products and services, including improving store layouts and digital content. </p>\n'
        + '    <p><br/></p> <p> Learning about customer trends and interests.</p>\n'
        + '    <p><br/></p> <p> Personalizing digital content.</p>\n'
        + '    <p><br/></p> <p> Delivering marketing communications and advertising.</p>\n'
        + '    <p><br/></p> <p> Identifying the devices you use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Fraud prevention, security, and asset protection.</p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, such as shipping \n'
        + '    vendors, providers of digital analytics services, and fraud prevention. </p> \n'
        + '    <p><br/></p> <p> Manufacturers of products and providers of extended warranty services.</p>\n'
        + '    <p><br/></p> <p> Joint marketing partners.</p> \n'
        + '    <p><br/></p> <p> Financial services companies, such as for home improvement loans, processing\n'
        + '    payments, and for managing The Home Depot credit card accounts.</p>\n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p> \n'
        + '    <p><br/></p> <p> Advertising partners. </p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'

    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> INTERNET ACTIVITY,  </p> \n'
        + '    <p><br/></p> <p> such as browsing history, search history, information about your interaction \n'
        + '    with our websites, applications, electronic communications, or advertisements, and \n'
        + '    information about your activities when using our in-store WiFi. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Directly from you or the devices you use to access digital services, \n'
        + '    such as websites, mobile applications, and applications for connected devices. </p> \n'
        + '    <p><br/></p> <p> Marketing companies that help us learn about our customers and the devices they use to access digital content..</p>\n'
        + '    <p><br/></p> <p> Companies that supplement our customer records with additional information.</p> \n'
        + '    <p><br/></p> <p> Social media platforms.</p>\n'
        + '    <p><br/></p> <p> Advertising companies and content publishers that present you with our ads. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Fulfilling orders and processing returns. </p>\n'
        + '    <p><br/></p> <p> Customer care.</p>\n'
        + '    <p><br/></p> <p> Communicating with you.</p> \n'
        + '    <p><br/></p> <p> Administering contests and promotions.</p>\n'
        + '    <p><br/></p> <p> Improving our products and services, including improving store layouts and digital content.</p>\n'
        + '    <p><br/></p> <p> Learning about customer trends and interests.</p> \n'
        + '    <p><br/></p> <p> Personalizing digital content. </p>\n'
        + '    <p><br/></p> <p> Delivering marketing communications and advertising. </p> \n'
        + '    <p><br/></p> <p> Identifying the devices you use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Fraud prevention, security, and asset protection. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as providers of digital analytics services and fraud prevention services. </p> \n'
        + '    <p><br/></p> <p> Joint marketing partners.</p> \n'
        + '    <p><br/></p> <p> Advertising partners. </p>\n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'

    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> COMMERCIAL INFORMATION,  </p> \n'
        + '    <p><br/></p> <p> such as products or services purchased, purchasing history,\n'
        + '    products or services you like, reviews you submit, or where you shop. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Directly from you or the devices you use to access digital services,\n'
        + '  such as websites, mobile applications, and applications for connected devices. </p> \n'
        + '    <p><br/></p> <p> Other customers that may provide us with your information to recommend a product or \n'
        + '    service, ship products to you, or list you as a recipient of products or services.</p> \n'
        + '    <p><br/></p> <p> Companies that provide services on our behalf (e.g., installers). </p>\n'
        + '    <p><br/></p> <p> Security and fraud prevention services that help us confirm that transactions '
        + '    are valid and otherwise help us protect our assets and you. </p>\n'
        + '    <p><br/></p> <p> Marketing companies that help us learn about our customers and the devices '
        + '    they use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Companies that supplement our customer records with additional information.</p>\n'
        + '    <p><br/></p> <p> Social media platforms. </p>\n'
        + '    <p><br/></p> <p> Advertising companies and content publishers that present you with our ads. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Fulfilling orders and processing returns. </p>\n'
        + '    <p><br/></p> <p> Customer care.</p>\n'
        + '    <p><br/></p> <p> Administering contests and promotions.</p> \n'
        + '    <p><br/></p> <p> Registering you for a website or program.</p> \n'
        + '    <p><br/></p> <p> Communicating with you. </p>\n'
        + '    <p><br/></p> <p> Improving our products and services, including improving store layouts and digital content.</p>\n'
        + '    <p><br/></p> <p> Learning about customer trends and interests.</p> \n'
        + '    <p><br/></p> <p> Personalizing digital content. </p>\n'
        + '    <p><br/></p> <p> Delivering marketing communications and advertising. </p> \n'
        + '    <p><br/></p> <p> Identifying the devices you use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Fraud prevention, security, and asset protection. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as shipping vendors,providers of digital analytics services and fraud prevention services. </p> \n'
        + '    <p><br/></p> <p> Manufacturers of products and providers of extended warranty services.</p> \n'
        + '    <p><br/></p> <p> Financial services companies, such as for home improvement loans, \n'
        + '    processing payments, and for managing The Home Depot credit card accounts. </p>\n'
        + '    <p><br/></p> <p> Joint marketing partners. </p>\n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Advertising partners. </p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'

    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> PAYMENT INFORMATION,  </p> \n'
        + '    <p><br/></p> <p> such as credit or debit card, check, PayPal account, or gift card, \n'
        + '     as well as available credit for The Home Depot credit card. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Directly from you. </p> \n'
        + '    <p><br/></p> <p> From financial institutions, payment processors, and other providers of \n'
        + '    financial products and services that we work with to provide you with financial services and offers.</p> \n'
        + '    <p><br/></p> <p> Companies that provide services on our behalf. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Fulfilling orders and processing returns. </p>\n'
        + '    <p><br/></p> <p> Customer care.</p>\n'
        + '    <p><br/></p> <p> Communicating with you regarding payment status.</p> \n'
        + '    <p><br/></p> <p> Collecting payments on behalf of our financial service providers.</p> \n'
        + '    <p><br/></p> <p> Fraud prevention, security, and asset protection. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as data storage providers. </p> \n'
        + '    <p><br/></p> <p> Financial services companies, such as for home improvement loans, \n'
        + '    processing payments, and for managing The Home Depot credit card accounts. </p>\n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'

    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> DEMOGRAPHIC INFORMATION,  </p> \n'
        + '    <p><br/></p> <p> such as age and gender. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Directly from you. </p> \n'
        + '    <p><br/></p> <p> Companies that provide services on our behalf (e.g., installers). </p>\n'
        + '    <p><br/></p> <p> Marketing companies that help us learn about our customers and the devices '
        + '    they use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Companies that supplement our customer records with additional information.</p>\n'
        + '    <p><br/></p> <p> Social media platforms. </p>\n'
        + '    <p><br/></p> <p> Advertising companies and content publishers that present you with our ads. </p>\n'
        + '    <p><br/></p> <p> Other customers that may provide us with your information to recommend a product or \n'
        + '    service, ship products to you, or list you as a recipient of products or services.</p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Improving our products and services, including improving store layouts and digital content.\n </p>'
        + '    <p><br/></p> <p> Communicating with you. </p>\n'
        + '    <p><br/></p> <p> Customer care.</p>\n'
        + '    <p><br/></p> <p>Administering contests and promotions. </p>\n'
        + '    <p><br/></p> <p>Learning about customer trends and interests.</p>\n'
        + '    <p><br/></p> <p>Personalizing digital content.</p>\n'
        + '    <p><br/></p> <p>Delivering marketing communications and advertising. </p>\n'
        + '    <p><br/></p> <p>Fraud prevention, security, and asset protection.  </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as such as shipping vendors, providers of digital analytics services, and fraud prevention services. </p> \n'
        + '    <p><br/></p> <p> Joint marketing partners.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Advertising partners.</p>\n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> LOCATION INFORMATION, </p> \n'
        + '    <p><br/></p> <p> such as location based on IP address or mobile device location information. \n'
        + '    (Please see the <a href="#TrackingTools"> Our Tracking Tools </a> section for additional information.) </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Directly from you or the devices you use to access digital services,\n'
        + '  such as websites, mobile applications, and applications for connected devices. </p> \n'
        + '    <p><br/></p> <p> Security and fraud prevention services that help us confirm that transactions '
        + '    are valid and otherwise help us protect our assets and you. </p>\n'
        + '    <p><br/></p> <p> Marketing companies that help us learn about our customers and the devices '
        + '    they use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Companies that supplement our customer records with additional information.</p>\n'
        + '    <p><br/></p> <p> Advertising companies and content publishers that present you with our ads. </p>\n'
        + '    <p><br/></p> <p> The signals emitted by your mobile devices when you travel through our stores. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Communicating with you. </p>\n'
        + '    <p><br/></p> <p> Customer care.</p>\n'
        + '    <p><br/></p> <p> Improving our products and services, including improving store layouts and digital content.</p>\n'
        + '    <p><br/></p> <p> Administering contests and promotions.</p> \n'
        + '    <p><br/></p> <p> Learning about customer trends and interests.</p> \n'
        + '    <p><br/></p> <p> Personalizing digital content. </p>\n'
        + '    <p><br/></p> <p> Delivering marketing communications and advertising. </p> \n'
        + '    <p><br/></p> <p> Identifying the devices you use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Fraud prevention, security, and asset protection. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as shipping vendors,providers of digital analytics services and fraud prevention services. </p> \n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Advertising partners. </p>\n'
        + '    <p><br/></p> <p> Joint marketing partners. </p>\n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'

    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> EMPLOYMENT INFORMATION, </p> \n'
        + '    <p><br/></p> <p> such as your profession, trade, or line of business. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Directly from you. </p> \n'
        + '    <p><br/></p> <p> Other customers that may provide us with your information to recommend a product or \n'
        + '    service, ship products to you, or list you as a recipient of products or services.</p> \n'
        + '    <p><br/></p> <p> Companies that supplement our customer records with additional information.</p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Fulfilling orders and processing returns.</p>\n'
        + '    <p><br/></p> <p> Registering you for a website or program.</p>\n'
        + '    <p><br/></p> <p> Communicating with you.</p> \n'
        + '    <p><br/></p> <p> Learning about customer trends and interests.</p> \n'
        + '    <p><br/></p> <p> Personalizing digital content. </p>\n'
        + '    <p><br/></p> <p> Fraud prevention, security, and asset protection. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as data storage providers and background check providers. </p> \n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'

    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> VIDEO RECORDINGS AND AUDIO RECORDINGS,  </p> \n'
        + '    <p><br/></p> <p> such as in-store CCTV and customer care calls. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Via cameras deployed in our stores, in parking lots, and at our warehouses and other facilities. </p> \n'
        + '    <p><br/></p> <p> Via call recordings.</p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Improving our products and services, including improving store layouts and digital content. </p>\n'
        + '    <p><br/></p> <p> Customer care.</p>\n'
        + '    <p><br/></p> <p> Learning about customer trends and interests.</p> \n'
        + '    <p><br/></p> <p> Fraud prevention, security, and asset protection. </p> \n'
        + '    <p><br/></p> <p> Training. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as security and fraud prevention services. </p> \n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'

    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> BIOMETRIC INFORMATION,  </p> \n'
        + '    <p><br/></p> <p> such as facial recognition. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Via cameras deployed in our stores, in parking lots, and at our warehouses \n'
        + '  and other facilities as permitted under applicable laws. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Fraud prevention, security, and asset protection. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as security and fraud prevention services. </p> \n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'

    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> PROPERTY INFORMATION,  </p> \n'
        + '    <p><br/></p> <p> such as home and property measurements, square footage, public record \n'
        + '    information, ownership information, estimated home value, and lot size. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Directly from you. </p> \n'
        + '    <p><br/></p> <p> Public records.</p> \n'
        + '    <p><br/></p> <p> Suppliers of property information, such as online property databases. </p>\n'
        + '    <p><br/></p> <p> Companies that supplement our customer records with additional information.</p>\n'
        + '    <p><br/></p> <p> Companies that provide services on our behalf (e.g., installers). </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Fulfilling orders and processing returns. </p>\n'
        + '    <p><br/></p> <p> Customer care.</p>\n'
        + '    <p><br/></p> <p> Administering contests and promotions.</p> \n'
        + '    <p><br/></p> <p> Registering you for a website or program.</p> \n'
        + '    <p><br/></p> <p> Communicating with you. </p>\n'
        + '    <p><br/></p> <p> Improving our products and services, including improving store layouts and digital content.</p>\n'
        + '    <p><br/></p> <p> Learning about customer trends and interests.</p> \n'
        + '    <p><br/></p> <p> Personalizing digital content. </p>\n'
        + '    <p><br/></p> <p> Delivering marketing communications and advertising. </p> \n'
        + '    <p><br/></p> <p> Identifying the devices you use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Fraud prevention, security, and asset protection. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as shipping vendors,providers of digital analytics services and fraud prevention services. </p> \n'
        + '    <p><br/></p> <p> Manufacturers of products and providers of extended warranty services.</p> \n'
        + '    <p><br/></p> <p> Joint marketing partners. </p>\n'
        + '    <p><br/></p> <p> Financial services companies, such as for home improvement loans, \n'
        + '    processing payments, and for managing The Home Depot credit card accounts. </p>\n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Advertising partners. </p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'

    }
  },
  {
    subHeader: {
      subHeading: 'CATEGORY OF PERSONAL INFORMATION',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> INFERENCES  </p> \n'
        + '    <p><br/></p> <p> regarding your preferences, interests, and other characteristics. </p>\n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHERE DO WE COLLECT IT FROM?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p> Directly from you. </p> \n'
        + '    <p><br/></p> <p> Companies that provide services on our behalf (e.g., installers \n'
        + '    and others that communicate with you about projects). </p>\n'
        + '    <p><br/></p> <p> Marketing companies that help us learn about our customers and the devices '
        + '    they use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Companies that supplement our customer records with additional information.</p>\n'
        + '    <p><br/></p> <p> Social media platforms. </p>\n'
        + '    <p><br/></p> <p> Advertising companies and content publishers that present you with our ads. </p>\n'
        + '    <p><br/></p> <p> By analyzing the information we collect about you and other customers.</p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHY DO WE COLLECT IT?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Communicating with you. </p>\n'
        + '    <p><br/></p> <p> Customer care.</p>\n'
        + '    <p><br/></p> <p> Improving our products and services, including improving store layouts and digital content.</p>\n'
        + '    <p><br/></p> <p> Learning about customer trends and interests.</p> \n'
        + '    <p><br/></p> <p> Administering contests and promotions.</p> \n'
        + '    <p><br/></p> <p> Personalizing digital content. </p>\n'
        + '    <p><br/></p> <p> Delivering marketing communications and advertising. </p> \n'
        + '    <p><br/></p> <p> Identifying the devices you use to access digital content.</p>\n'
        + '    <p><br/></p> <p> Fraud prevention, security, and asset protection. </p> \n'
    }
  },
  {
    subHeader: {
      subHeading: 'WHO DO WE SHARE IT WITH?',
    },
    textOpt: {
      id: 'WhatWeCollect',
      html: '<p><br/></p> <p><br/></p> <p> Service providers that process information on our behalf, \n'
        + '    such as shipping vendors,providers of digital analytics services and fraud prevention services. </p> \n'
        + '    <p><br/></p> <p> Joint marketing partners. </p>\n'
        + '    <p><br/></p> <p> Any successor to all or part of our business.</p>\n'
        + '    <p><br/></p> <p> Advisors and consultants.</p>\n'
        + '    <p><br/></p> <p> Advertising partners. </p>\n'
        + '    <p><br/></p> <p> Law enforcement, public and government authorities, and other entities as '
        + '    we deem reasonably necessary to comply with law, support investigations, and protect the '
        + '    rights and property of you, us, and others. </p>\n'
        + '    <p><br/></p> <p> Our affiliates and subsidiaries.</p>\n'

    }
  }
];
